import { Outlet } from 'react-router-dom';
import styles from './AuthLayout.module.css';
import { LoginFooter } from '@/features/auth/components/LoginFooter';

interface AuthLayoutProps {
  variant?: 'card' | 'bare';
}

export default function AuthLayout({ variant = 'card' }: AuthLayoutProps) {
  const isBare = variant === 'bare';

  return (
    <div className={styles.layout}>
      <div className={`${styles.container} ${isBare ? styles.containerBare : ''}`}>
        <div className={`${styles.logo} ${isBare ? styles.logoBare : ''}`}>
          <img src="/logo_delta.svg" alt="delt.ai" width={64} height={64} />
        </div>
        <div className={isBare ? styles.contentBare : styles.content}>
          <Outlet />
        </div>
      </div>

      <LoginFooter />
    </div>
  );
}

export { AuthLayout };
